import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { forwardRef, useContext, useImperativeHandle, useRef } from 'react';
import { DropdownContextInstance } from '../types/context';
import { getIdForDropdownListItem } from '../utils';
const b = bemClassBuilder('v-dropdown-list-item');
const DropdownListItemBase = (props, ref) => {
    const listItemRef = useRef(null);
    const { option } = props;
    const { dropdownId, selectedOption, optionTemplate: OptionTemplate, onOptionClicked, displayAsModalOnMobile } = useContext(DropdownContextInstance);
    const isSelected = (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) === option.value;
    const handleClick = () => {
        if (option.disabled) {
            return;
        }
        onOptionClicked(option);
    };
    useImperativeHandle(ref, () => ({
        scrollIntoView: () => {
            var _a;
            (_a = listItemRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ block: 'nearest' }); // TODO: Improve this to work with all browsers. #286592
        }
    }));
    const classModifiers = {
        selected: isSelected,
        inMobileModal: displayAsModalOnMobile,
        disabled: option.disabled
    };
    return (_jsx("li", { className: b.block(classModifiers), id: getIdForDropdownListItem(dropdownId, option), role: "option", onClick: handleClick, tabIndex: -1, ref: listItemRef, children: _jsx(OptionTemplate, Object.assign({}, option)) }));
};
export const DropdownListItem = observer(forwardRef(DropdownListItemBase));
DropdownListItem.displayName = 'DropdownListItem';
//# sourceMappingURL=list-item.js.map